import type { ServerEvent } from "@maimu/contracts";
import { parseServerEventFrame } from "@maimu/contracts";

/**
 * Reads an SSE body from a `fetch` response.
 *
 * EventSource cannot send an Authorization header, so the chat request is a normal
 * POST and the event stream is parsed here. Frames can split across chunks, so the
 * tail is buffered until the next blank-line boundary arrives.
 */
export async function* readServerEvents(response: Response): AsyncGenerator<ServerEvent> {
  if (!response.body) throw new Error("Vastuse voog puudub.");

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });

      let boundary = buffer.indexOf("\n\n");
      while (boundary !== -1) {
        const frame = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        boundary = buffer.indexOf("\n\n");

        const event = parseServerEventFrame(frame);
        if (event) yield event;
      }
    }

    const trailing = parseServerEventFrame(buffer);
    if (trailing) yield trailing;
  } finally {
    reader.releaseLock();
  }
}
